import { create } from "zustand";

interface GuideModalStore {
  dismissed: boolean;
  dismiss: () => void;
}

/**
 * 홈 이용가이드 플로팅 모달을 닫았는지.
 *
 * 사이드바는 페이지마다 새로 마운트되므로, 화면을 오가는 동안 닫힌 상태가 유지되도록 컴포넌트 밖에 둔다.
 * 새로고침하면 다시 띄우는 게 의도라 저장하지 않는다.
 */
export const useGuideModalStore = create<GuideModalStore>()((set) => ({
  dismissed: false,
  dismiss: () => set({ dismissed: true }),
}));
